import { Link } from "react-router-dom";
import DocNavigation from "../../components/DocNavigation";

export default function ContactUs() {
    return (
        <section className="space-y-10">

            {/* HEADER */}
            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-2">
                    Contact Us
                </h1>

                <p className="text-md text-slate-600 max-w-3xl">
                    We’re here to help you understand EventFlow, resolve queries, and
                    support your operational needs.
                </p>

                <section className="bg-white border-l border-[#C9A24E] p-4 mt-4">
                    <h2 className="text-lg font-semibold mb-2">Overview</h2>
                    <p className="text-sm text-slate-600">
                        Reach out to us for product inquiries, support, or collaboration.
                    </p>
                </section>
            </section>

            {/* REASONS */}
            <section className="bg-slate-100 rounded-xl p-10">
                <h2 className="text-xl font-semibold mb-3">
                    When to Contact Us
                </h2>

                <ul className="list-disc pl-5 text-slate-600 space-y-2">
                    <li>Product demonstrations and walkthroughs</li>
                    <li>Pricing inquiries and custom quote requests</li>
                    <li>Technical assistance and troubleshooting</li>
                    <li>Feature requests and customization discussions</li>
                    <li>Partnership and integration opportunities</li>
                </ul>
            </section>

            {/* BUSINESS HOURS */}
            <section className="bg-white border border-slate-200 rounded-xl p-10">
                <h2 className="text-xl font-semibold mb-4">
                    Business Hours
                </h2>
                <div className="grid md:grid-cols-2 gap-6">
                    <div>
                        <h3 className="font-semibold text-slate-800 mb-2">Support Team</h3>
                        <p className="text-sm text-slate-600">
                            Monday - Saturday: 9:00 AM - 9:00 PM (PKT)<br />
                        </p>
                    </div>
                    {/* <div>
                        <h3 className="font-semibold text-slate-800 mb-2">Sales Team</h3>
                        <p className="text-sm text-slate-600">
                            Monday - Friday: 9:00 AM - 5:00 PM (EST)<br />
                            Weekends: By Appointment Only
                        </p>
                    </div> */}
                </div>
            </section>

            {/* COMMUNICATION */}
            <section className="bg-slate-100 rounded-xl p-10">
                <h2 className="text-xl font-semibold mb-4">
                    Communication Channels
                </h2>

                <div className="space-y-6">
                    <div>
                        <h3 className="text-lg font-medium text-slate-800 mb-1">Email Support</h3>
                        <p className="text-slate-600 mb-2">
                            For general inquiries and support tickets.
                        </p>
                        <a href="mailto:support@eventflow.com" className="text-[#C9A24E] font-medium hover:underline">
                            info@methologik.com
                        </a>
                        <p className="text-xs text-slate-500 mt-1">Response time: Within 24 hours</p>
                    </div>

                    <div>
                        <h3 className="text-lg font-medium text-slate-800 mb-1">Phone Support</h3>
                        <p className="text-slate-600 mb-2">
                            Speak directly with our support specialists.
                        </p>
                        <a href="tel:+18005550199" className="text-[#C9A24E] font-medium hover:underline">
                            +92 (333) 722-3262
                        </a>
                        <p className="text-xs text-slate-500 mt-1">Available during business hours</p>
                    </div>

                    {/* <div>
                        <h3 className="text-lg font-medium text-slate-800 mb-1">Live Chat</h3>
                        <p className="text-slate-600">
                            Available on our dashboard for subscribed users for instant assistance.
                        </p>
                    </div> */}
                </div>
            </section>

            {/* OUR OFFICES */}
            <section className="bg-white border border-slate-200 rounded-xl p-10">
                <h2 className="text-xl font-semibold mb-4">
                    Our Offices
                </h2>
                <div className="grid md:grid-cols-2 gap-8">
                    <div>
                        <h3 className="font-semibold text-slate-800 mb-2">Headquarters</h3>
                        <p className="text-sm text-slate-600">
                            Karachi,<br />

                            Pakistan
                        </p>
                    </div>
                    <div>
                        <h3 className="font-semibold text-slate-800 mb-2">Regional Headquarters</h3>
                        <p className="text-sm text-slate-600">
                            Riyadh,<br />

                            Saudia Arabia
                        </p>
                    </div>
                </div>
            </section>

            {/* <section className="border-t pt-8 mt-12">
                <p className="text-slate-600">
                    Next, read{" "}
                    <Link to="/docs/support" className="font-medium text-[#C9A24E]">
                        FAQs
                    </Link>.
                </p>
            </section> */}

            <DocNavigation
                previous={{
                    title: "Support",
                    link: "/docs/support"
                }}
                next={{
                    title: "FAQs",
                    link: "/docs/faqs"
                }}
            />

        </section>
    );
}
